import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalType, setModalType] = useState(null);
  const [modalPayload, setModalPayload] = useState({});

  const openModal = (type, payload = {}) => {
    setModalType(type);
    setModalPayload(payload);
  };

  const closeModal = () => {
    setModalType(null);
    setModalPayload({});
  };

  return (
    <ModalContext.Provider value={{ modalType, modalPayload, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
